import { render } from "./Schnellkachel.vue?vue&type=template&id=0c5e526c&scoped=true"
import script from "./Schnellkachel.vue?vue&type=script&lang=js"
export * from "./Schnellkachel.vue?vue&type=script&lang=js"

import "./Schnellkachel.vue?vue&type=style&index=0&id=0c5e526c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c5e526c"]])

export default __exports__